import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hres4ax/mocker'
let configLabels = require('src/../config/label')

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/hres4ax/getLabels')
  },
  getIndex (searchParams) {
    let pDteeffest = '01011000'
    let pDteeffeen = '31129999'
    let objUsrcom = configLabels.getUsrCom()
    let pCodcompyList = Object.keys(objUsrcom).map(function (key) {
      return objUsrcom[key]
    }).join(',') || 'xxx'
    let sendParams = {}

    if (typeof searchParams !== 'undefined') {
      pDteeffest = searchParams.dteeffest || pDteeffest
      pDteeffeen = searchParams.dteeffeen || pDteeffeen
      sendParams = {
        p_codcompy: (typeof searchParams.codcompy !== 'undefined' ? searchParams.codcompy : '%')
      }
    }
    let param = pDteeffest.replace(/\//g, '') + '/' + pDteeffeen.replace(/\//g, '') + '/' + pCodcompyList
    if (isMock) return generator(mocker.index())
    return instance().get(endpoint + '/hres4ax/index/' + param, { params: sendParams })
  },
  getDetail (dataRow) {
    if (isMock) return generator(mocker.detail())
    let searchParams = {
      p_codcompy: dataRow.codcompy,
      p_codlinef: dataRow.codlinef,
      p_dteeffec: dataRow.dteeffec
    }
    const params = searchParams.p_codcompy + '/' + searchParams.p_codlinef + '/' + searchParams.p_dteeffec.replace(/\//g, '')
    return instance().get(endpoint + '/hres4ax/orgNode/' + params)
  },
  getPopup1 (dataRow) {
    if (isMock) return generator(mocker.popup1())
    let searchParams = {
      p_codcompy: dataRow.codcompy,
      p_codlinef: dataRow.codlinef,
      p_dteeffec: dataRow.dteeffec,
      p_codcomp: dataRow.codcomp,
      p_codpos: dataRow.codpospr
    }
    const params = searchParams.p_codcompy + '/' + searchParams.p_codlinef + '/' + searchParams.p_dteeffec.replace(/\//g, '') + '/' + searchParams.p_codcomp + '/' + searchParams.p_codpos
    return instance().get(endpoint + '/hres4ax/popup1/' + params)
  },
  getPopup2 (dataRow) {
    if (isMock) return generator(mocker.popup2())
    let searchParams = {
      p_codcomp: dataRow.codcomp,
      p_codpos: dataRow.codpospr
    }
    const params = searchParams.p_codcomp + '/' + searchParams.p_codpos
    return instance().get(endpoint + '/hres4ax/popup2/' + params)
  }
}



// WEBPACK FOOTER //
// ./src/api/hres4ax/index.js